import { defineMessages } from "react-intl";

export const messages = defineMessages({
	personalData: {
		id: "form.patient.personal_data",
		defaultMessage: "Személyes adatok"
	},
	contactDetails: {
		id: "form.patient.contact_details",
		defaultMessage: "Elérhetőségi adatok"
	},
	connectedUsers: {
		id: "form.patient.connected_users",
		defaultMessage:
			"Adathozzáféréssel rendelkező felhasználók (e-mail értesítéseket is kapnak)"
	},
	generalPractitionerData: {
		id: "form.patient.general_practitioner_data",
		defaultMessage: "Háziorvos adatai"
	},
	socialSecurityNumber: {
		id: "form.patient.social_security_number",
		defaultMessage: "TAJ szám"
	},
	socialSecurityNumberHelp: {
		id: "form.patient.social_security_number.help",
		defaultMessage:
			"TAJ szám módosítással kapcsolatban kérjük írjon üzenetet az info@fyrms.com e-mail címre."
	},
	patientHospitalNumber: {
		id: "form.patient.patient_hospital_number",
		defaultMessage: "KBA szám"
	},
	patientHospitalNumberHelp: {
		id: "form.patient.patient_hospital_number_help",
		defaultMessage: "Kórházi beteg azonosító"
	},
	dateOfBirth: {
		id: "form.patient.date_of_birth",
		defaultMessage: "Születési dátum"
	},
	countryOfBirth: {
		id: "form.patient.country_of_birth",
		defaultMessage: "Születési ország"
	},
	placeOfBirth: {
		id: "form.patient.place_of_birth",
		defaultMessage: "Születési hely"
	},
	sex: {
		id: "form.patient.sex",
		defaultMessage: "Nem"
	},
	title: {
		id: "form.patient.title",
		defaultMessage: "Titulus"
	},
	firstName: {
		id: "form.patient.first_name",
		defaultMessage: "Keresztnév"
	},
	lastName: {
		id: "form.patient.last_name",
		defaultMessage: "Vezetéknév"
	},
	maidenName: {
		id: "form.patient.maiden_name",
		defaultMessage: "Születési név"
	},
	maidenNameOfMother: {
		id: "form.patient.maiden_name_of_mother",
		defaultMessage: "Anyja leánykori neve"
	},
	phoneNumber: {
		id: "form.patient.phone_number",
		defaultMessage: "Telefonszám"
	},
	email: {
		id: "form.patient.email",
		defaultMessage: "Email cím"
	},
	country: {
		id: "form.patient.country",
		defaultMessage: "Ország"
	},
	county: {
		id: "form.patient.county",
		defaultMessage: "Megye"
	},
	postCode: {
		id: "form.patient.post_code",
		defaultMessage: "Irányítószám"
	},
	city: {
		id: "form.patient.city",
		defaultMessage: "Település"
	},
	addressLineOne: {
		id: "form.patient.address_line_one",
		defaultMessage: "Cím"
	},
	addressLineTwo: {
		id: "form.patient.address_line_two",
		defaultMessage: "Cím kiegészítés"
	},
	user: {
		id: "form.patient.user",
		defaultMessage: "Felhasznaló"
	},
	hasGeneralPractitioner: {
		id: "form.patient.has_general_practitioner",
		defaultMessage: "Adatok megadása"
	},
	stampNumber: {
		id: "form.patient.stamp_number",
		defaultMessage: "Pecsétszám"
	},
	medicalPractitionerHospitalNumber: {
		id: "form.patient.medical_practitioner_hospital_number",
		defaultMessage: "Kórházi azonosító"
	},
	socialSecurityNumberRequired: {
		id: "form.patient.social_security_number.error.required",
		defaultMessage: "A TAJ szám kötelező."
	},
	socialSecurityNumberFormat: {
		id: "form.patient.social_security_number.error.format",
		defaultMessage: "A TAJ szám formátuma nem megfelelő."
	},
	socialSecurityNumberUsed: {
		id: "form.patient.social_security_number.error.used",
		defaultMessage: "A TAJ szám már használatban van."
	},
	patientHospitalNumberRequired: {
		id: "form.patient.patient_hospital_number.error.required",
		defaultMessage: "A KBA szám kötelező."
	},
	patientHospitalNumberFormat: {
		id: "form.patient.patient_hospital_number.error.format",
		defaultMessage: "A KBA szám formátuma nem megfelelő."
	},
	dateOfBirthRequired: {
		id: "form.patient.date_of_birth.error.required",
		defaultMessage: "A születési dátum kötelező."
	},
	countryOfBirthRequired: {
		id: "form.patient.country_of_birth.error.required",
		defaultMessage: "A születési ország kötelező."
	},
	placeOfBirthRequired: {
		id: "form.patient.place_of_birth.error.required",
		defaultMessage: "A születési hely kötelező."
	},
	placeOfBirthValue: {
		id: "form.patient.place_of_birth.error.value",
		defaultMessage: "A születési hely nem megfelelő."
	},
	sexRequired: {
		id: "form.patient.sex.error.required",
		defaultMessage: "A nem kötelező."
	},
	firstNameRequired: {
		id: "form.patient.first_name.error.required",
		defaultMessage: "A keresztnév kötelező."
	},
	lastNameRequired: {
		id: "form.patient.last_name.error.required",
		defaultMessage: "A vezetéknév kötelező."
	},
	maidenNameRequired: {
		id: "form.patient.maiden_name.error.required",
		defaultMessage: "A születési név kötelező."
	},
	maidenNameOfMotherRequired: {
		id: "form.patient.maiden_name_of_mother.error.required",
		defaultMessage: "Az anyja leánykori neve kötelező."
	},
	phoneNumberRequired: {
		id: "form.patient.phone_number.error.required",
		defaultMessage: "A telefonszám kötelező."
	},
	phoneNumberFormat: {
		id: "form.patient.phone_number.error.format",
		defaultMessage: "A telefonszám formátuma nem megfelelő."
	},
	emailRequired: {
		id: "form.patient.email.error.required",
		defaultMessage: "Az email cím kötelező."
	},
	emailFormat: {
		id: "form.patient.email.error.format",
		defaultMessage: "Az email cím formátuma nem megfelelő."
	},
	countryRequired: {
		id: "form.patient.country.error.required",
		defaultMessage: "Az ország kötelező."
	},
	countyRequired: {
		id: "form.patient.county.error.required",
		defaultMessage: "Az megye kötelező."
	},
	countyValue: {
		id: "form.patient.county.error.value",
		defaultMessage: "Az megye nem megfelelő."
	},
	postCodeRequired: {
		id: "form.patient.post_code.error.required",
		defaultMessage: "Az irányítószám kötelező."
	},
	postCodeValue: {
		id: "form.patient.post_code.error.value",
		defaultMessage: "A irányítószám nem megfelelő."
	},
	cityRequired: {
		id: "form.patient.city.error.required",
		defaultMessage: "A település kötelező."
	},
	cityValue: {
		id: "form.patient.city.error.value",
		defaultMessage: "A település nem megfelelő."
	},
	addressRequired: {
		id: "form.patient.address.error.required",
		defaultMessage: "A cím kötelező."
	},
	userRequired: {
		id: "form.patient.user.error.required",
		defaultMessage: "A felhasználó kötelező."
	},
	stampNumberRequired: {
		id: "form.patient.stamp_number.error.required",
		defaultMessage: "A pecsétszám kötelező."
	},
	stampNumberFormat: {
		id: "form.patient.stamp_number.error.format",
		defaultMessage: "A pecsétszám formátuma nem megfelelő."
	}
});
